/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { createContext, useContext } from 'react';
export var SearchTriggerInputContext = /*#__PURE__*/createContext(null);
export var useSearchTriggerInput = function useSearchTriggerInput() {
  var context = useContext(SearchTriggerInputContext);
  if (!context) {
    throw new Error('useSearchTriggerInput must be used within a SearchTriggerInputProvider');
  }
  return context;
};